define('modules/CookieNotice',[], function () {
    'use strict';

    var module = {
        _loadCSS: false,
        init: function($element) {
            var d = window.document;
            var id = {
                cookieNotice: 'cookie-notice',
                acceptButton: 'cookie-notice-accept',
                acceptAllButton: 'cookie-notice-accept-all',
                checkboxMandatory: 'cookie-checkbox-mandatory',
                checkboxTracking: 'cookie-checkbox-tracking',
                checkboxThirdParty: 'cookie-checkbox-thirdparty'
            };
            var cssClass = {
                reEditButton: 'footer__link footer__link--cookie-edit',
                reEditButtonMedia: 'js-cookie-link',
                reEditButtonWrapperTag: 'footer__list-item',
                reEditButtonWrapperTagMedia: 'js-cookie-link-wrapper',
                disabled: 'js-disabled',
                mediaUnprocessed: 'js-unprocessed'
            };
            var selector = {
                // reEditButton (& wrapper) inserted here
                reEditButtonParent: '.footer-menu .horizontal-list',
                mediaContainer: '.media-external:not(.video-internal), .audio, .locations',
                mediaBlockedExplainer: '.video__blocked-explainer, .audio__blocked-explainer'
            };
            var reEditButtonWrapperTag = 'li';
            var reEditButtonWrapperTagMedia = 'p';
            var ariaRole = 'alert';
            // Number of days before cookie expires
            var expiresDays = 365;
            var keyList = {
                esc: 27
            };
            var dataSet = {
                cookieName: 'cookieName',
                isTracking: 'isTracking',
                isThirdParty: 'isThirdParty',
                src: 'src',
                title: 'title'
            };
            var cookieBar,
                acceptButton,
                acceptAllButton,
                reEditButton,
                checkboxes,
                mediaContainers,
                setup,
                getReEditButton,
                closeCookieBar,
                enhanceAcceptAll,
                setNoticeAccepted,
                toggleMedia,
                setInitialState,
                initialize;






            /**
             * Set up base functionality
             */
            setup = function () {
                // Only processed if notice exists
                if (!cookieBar || !acceptButton) {
                    return;
                }

                enhanceAcceptAll();

                reEditButton = getReEditButton();

                acceptButton.setAttribute('aria-controls', id.cookieNotice);

                acceptButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    setNoticeAccepted(cookieBar, reEditButton);

                    return false;
                });

                setInitialState();

                window.addEventListener('keyup', function (e) {
                    // If ESC key pressed when notice open, close it - standard behaviour. No auto-accept, will re-show on next page
                    if (e.keyCode === keyList.esc && cookieBar.getAttribute('role') === ariaRole) {
                        closeCookieBar(cookieBar, reEditButton);
                    }
                });

                if (cookieBar.dataset.role === ariaRole) {
                    window.addEventListener('load', function () {
                        // Move to first item to ensure better keyboard access and in case AT doesn't recognize role->alert switch. Start at end of page for SEO etc
                        d.body.insertBefore(cookieBar, d.body.firstChild);
                        // Switch role to grab screenreader attention
                        cookieBar.setAttribute('role', ariaRole);
                    });
                } else {
                    reEditButton.parentNode.appendChild(cookieBar);
                }
            };

            /**
             * Add behaviour to accept-all button
             */
            enhanceAcceptAll = function () {
                if (!acceptAllButton) {
                    return;
                }

                acceptAllButton.setAttribute('aria-controls', id.cookieNotice);

                acceptAllButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    checkboxes.forEach(function (input) {
                        if (input) {
                            input.checked = true;
                        }
                    });

                    acceptButton.click();

                    return false;
                });
            };

            /**
             * Add button to toggle the cookie-settings layer
             * @param customInsertionNode
             * @returns {*}
             */
            getReEditButton = function (customInsertionNode) {
                var control = d.createElement('button');
                var wrapper = customInsertionNode ? d.createElement(reEditButtonWrapperTagMedia) : d.createElement(reEditButtonWrapperTag);
                var insertionNode = customInsertionNode || d.querySelector(selector.reEditButtonParent);
                var ariaExpanded = cookieBar.getAttribute('role') === ariaRole ? 'true' : 'false';

                control.className = customInsertionNode ? cssClass.reEditButtonMedia : cssClass.reEditButton;
                control.setAttribute('aria-controls', cookieBar.id);
                control.setAttribute('aria-expanded', ariaExpanded);
                control.innerHTML = cookieBar.dataset.toggleText;

                wrapper.className = customInsertionNode ? cssClass.reEditButtonWrapperTagMedia : cssClass.reEditButtonWrapperTag;

                if (insertionNode) {
                    insertionNode.appendChild(wrapper);
                    wrapper.appendChild(control);
                } else {
                    d.body.appendChild(control);
                }

                control.addEventListener('click', function () {
                    cookieBar.setAttribute('role', ariaRole);
                    control.setAttribute('aria-expanded', 'true');

                    return false;
                });

                return control;
            };

            /**
             * Close cookie notice and set a seen-notice cookie
             * @param cookieBar
             * @param reEditButton
             */
            setNoticeAccepted = function (cookieBar, reEditButton) {
                var expires = new Date();

                expires.setDate(expires.getDate() + expiresDays);

                checkboxes.forEach(function (input) {
                    // Only proceed if can identify which cookie to set/change
                    if (!input.dataset[dataSet.cookieName]) {
                        return;
                    }

                    /* eslint-disable no-underscore-dangle */
                    if (input.checked) {
                        if (input.dataset[dataSet.isTracking] && !window._paq) {
                            // Remove any consent_removed cookie
                            d.cookie = 'mtm_consent_removed=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;samesite=lax';

                            // Tracking wanted - enable, if not already running
                            window.enableTracking();
                        } else if (input.dataset[dataSet.isThirdParty]) {
                            toggleMedia(true);
                            if ($('.locations').length > 0) {
                                window.location.reload();
                            }
                        }

                        d.cookie = input.dataset[dataSet.cookieName] + '=1;expires=' + expires.toUTCString() + ';path=/;samesite=lax';
                    } else {
                        if (input.dataset[dataSet.isTracking] && window._paq) {
                            window._paq.push(['forgetConsentGiven']);

                            // Remove any Matomo session cookie
                            d.cookie = 'MATOMO_SESSID=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;samesite=lax';
                        } else if (input.dataset[dataSet.isThirdParty]) {
                            toggleMedia(false);
                        }

                        d.cookie = input.dataset[dataSet.cookieName] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;samesite=lax';
                    }
                    /* eslint-enable no-underscore-dangle */
                });

                closeCookieBar(cookieBar, reEditButton);
            };

            /**
             * Enable / disable media iframes
             * @param enable
             * @param firstRun
             */
            toggleMedia = function (enable, firstRun) {

                mediaContainers.forEach(function (mediaContainer) {
                    var iframe = mediaContainer.querySelector('iframe');

                    if (enable) {
                        mediaContainer.classList.remove(cssClass.disabled);

                        if (iframe) {
                            iframe.title = iframe.dataset[dataSet.title];
                            iframe.src = iframe.dataset[dataSet.src];
                        }
                    } else {
                        mediaContainer.classList.add(cssClass.disabled);

                        if (iframe) {
                            iframe.removeAttribute('title');
                            iframe.src = 'about:blank';
                        }
                    }

                    if (firstRun) {
                        getReEditButton(mediaContainer.parentNode.querySelector(selector.mediaBlockedExplainer));

                        mediaContainer.classList.remove(cssClass.mediaUnprocessed);
                    }
                });

                if (enable) {
                    $('.video-popup').addClass('active');
                } else {
                    $('.video-popup').removeClass('active');
                }
            };

            /**
             * Ensure no browser not autocompleting wrong checkbox state
             * Set media elements to current state
             */
            setInitialState = function () {
                checkboxes.forEach(function (input, i) {
                    var enabled;

                    if (i === 0) {
                        input.checked = true;
                    } else {
                        enabled = document.cookie.indexOf(input.dataset[dataSet.cookieName]) > -1;
                        input.checked = enabled;

                        if (input.dataset[dataSet.isThirdParty]) {
                            toggleMedia(enabled, true);
                        }
                    }
                });
            };

            /**
             * Close the cookieBar
             * @param cookieBar
             * @param reEditButton
             */
            closeCookieBar = function (cookieBar, reEditButton) {
                cookieBar.removeAttribute('role');
                reEditButton.setAttribute('aria-expanded', 'false');

                // First page view, so notice currently 1st node on page. Now move it after the button that re-opens it
                if (cookieBar.dataset.role === ariaRole) {
                    reEditButton.parentNode.appendChild(cookieBar);
                    // No longer needed and cannot be hidden until removed
                    cookieBar.removeAttribute('data-role');
                }
            };

            /**
             * Initialize the module
             */
            initialize = function () {
                // Only ever one cookie-notice, so make these available to entire module
                cookieBar = d.getElementById(id.cookieNotice);
                acceptButton = d.getElementById(id.acceptButton);
                acceptAllButton = d.getElementById(id.acceptAllButton);
                checkboxes = [d.getElementById(id.checkboxMandatory), d.getElementById(id.checkboxTracking), d.getElementById(id.checkboxThirdParty)];
                // checkboxes = [d.getElementById(id.checkboxMandatory), d.getElementById(id.checkboxTracking)];
                mediaContainers = d.querySelectorAll(selector.mediaContainer);

                setup();
            };

            initialize();
        },
    };

    return module;
});
